var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 39,
    rx: 8.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 39,
    rx: 8.5,
    stroke: "#CCCCCC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6637_43705)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6637_43705)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6637_43705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6689 20.6585L26.1696 27.0962H24.3225L20.6498 21.843V21.8427L20.1106 21.0716L15.8203 14.9346H17.6674L21.1297 19.8874L21.6689 20.6585Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.839 11H13.161C11.9676 11 11 11.9676 11 13.161V28.839C11 30.0324 11.9676 31 13.161 31H28.839C30.0324 31 31 30.0324 31 28.839V13.161C31 11.9676 30.0324 11 28.839 11ZM23.7566 27.9604L20.0401 22.5514L15.387 27.9604H14.1844L19.5061 21.7746L14.1844 14.0293H18.2434L21.7627 19.1513L26.1689 14.0293H27.3715L22.2968 19.9283H22.2965L27.8156 27.9604H23.7566Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6637_43705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11 11)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6637_43705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11 11)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6637_43705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBlack);
export default __webpack_public_path__ + "static/media/twitter-black.32b13fce89985da6fea9a0e74374c974.svg";
export { ForwardRef as ReactComponent };